export const API_HOST = process.env.REACT_APP_API_HOST;
export const API_URL_WS = process.env.REACT_APP_API_URL_WS;

console.log(API_HOST);


export const API_URL = `${API_HOST}/api/`;